// bao migrate skip
import * as $ from "jquery";
import "bootstrap_datetimepicker";
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import * as moment from "moment";
var Directions = {
    Today: 'Today',
    Forward: 'Forward',
    Backward: 'Backward'
};
var baoDatePicker: KnockoutBindingHandler = {
    after: ["baoDateTimeBox"],
    init: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
        var config: Bindings.baoDateTimePicker = valueAccessor();
        var defaults = {};
        var disabled = false;
        var showNavigation = ko.unwrap(config.showNavigation) || false;
        var maxWidth = ko.unwrap(config.maxWidth);
        var navigate = function (direction) {
            var dateTimePicker = $container.data('DateTimePicker');
            var currentDate = moment(dateTimePicker.date());
            if (currentDate && currentDate.isValid()) {
                var newDate;
                switch (direction) {
                    case Directions.Today:
                        newDate = moment().startOf('day'); // get now - rounded by day
                        break;
                    case Directions.Forward:
                        newDate = currentDate.add(1, 'd');
                        break;
                    case Directions.Backward:
                        newDate = currentDate.subtract(1, 'd');
                        break;
                }
                if (newDate && newDate.isValid()) {
                    dateTimePicker.date(newDate);
                }
            }
        };
        ////Image
        //TODO bs4: the out commented templates are for bs4!
        // const inputDiv = "<div class='input-group date'></div>";
        // const calendarBtn = "<div class='input-group-prepend input-group-addon'><button class='btn btn-default'><i class='fal fa-calendar-alt'></i></button></div>";
        // const $backwardBtn = $("<div class='input-group-prepend input-group-addon' style='cursor:pointer;'><button class='btn btn-default'><i class='fal fa-arrow-alt-left'></i></button></div>");
        // const $forwardBtn = $("<div class='input-group-append input-group-addon' style='cursor:pointer;'><button class='btn btn-default'><i class='fal fa-arrow-alt-right'></i></button></div>");

        const inputDiv = "<div class='input-group date'></div>";
        const calendarBtn = "<span class='input-group-addon' style='cursor:pointer;'><span class='fal fa-calendar'></span></span>";
        const $backwardBtn = $("<span class='input-group-addon' style='cursor:pointer;'><i class='fal fa-backward'></i></span>");
        const $forwardBtn = $("<span class='input-group-addon' style='cursor:pointer;'><i class='fal fa-forward'></i></span>");

        let forwardEvent, backwardEvent;
        disabled = ko.unwrap(config.disabled);
        if (!disabled) {
            $(element).wrap(inputDiv);
            if ($(element).hasClass("isMandatory")) {
                $(element).parent().addClass("isMandatory");
            }
            if (ko.unwrap(config.maxWidth) != null) {
                $(element).parent().css("max-width", ko.unwrap(config.maxWidth));
            }
            $(element).after(calendarBtn);
            if (showNavigation) {
                $(element).css("text-align", "center");
                forwardEvent = function (event) {
                    event.stopImmediatePropagation();
                    const f = ko.unwrap(valueAccessor().forward);
                    if (f != null) {
                        f();
                    } else {
                        navigate(Directions.Forward);
                    }
                };
                backwardEvent = function (event) {
                    event.stopImmediatePropagation();
                    const b = ko.unwrap(valueAccessor().backward);
                    if (b != null) {
                        b();
                    } else {
                        navigate(Directions.Backward);
                    }
                };
                $forwardBtn.click(forwardEvent);
                $backwardBtn.click(backwardEvent);
                $(element).before($backwardBtn);
                $(element).after($forwardBtn);
            }
        }
        const $container = $(element).parent();
        let baseChange;
        if (config.change != null) {
            baseChange = config.change;
        }
        const options: any = $.extend(defaults, {}, config);
        let _triggerChange = true;
        options.change = function () {
            if (_triggerChange) {
                _triggerChange = false;
                $(element).change();
                if (baseChange != null) {
                    baseChange();
                }
            } else {
                setTimeout(function () {
                    _triggerChange = true;
                }, 0);
            }
        };
        // the format defines the mode!
        var mode = ko.utils.unwrapObservable(config.mode);
        if (mode == "" || mode == null) {
            mode = "date";
        }
        options.icons = {
            time: "fal fa-clock",
            date: "fal fa-calendar",
            up: "fal fa-arrow-up",
            down: "fal fa-arrow-down",
            previous: 'fal fa-chevron-left',
            next: 'fal fa-chevron-right',
            clear: 'fal fa-trash-alt',
            close: 'fal fa-remove'
        };
        options.format = "";
        switch (mode) {
            case "time":
                // use default format
                options.icons.date = "fal fa-clock";
                options.format = moment.localeData().longDateFormat("LT");
                break;
            case "datetime":
                options.format = false;
                break;
            case "date":
                options.format = moment.localeData().longDateFormat("L");
                break;
            case "datetimesec":
                options.format = moment.localeData().longDateFormat("L") + " " + moment.localeData().longDateFormat("LTS");
                break;
            case "custom":
                options.format = ko.unwrap(config.customFormat);
                break;
        }
        if (options.culture == null) {
            options.culture = ko.unwrap(Bao.Session.Language.Symbol);
        }
        $container.on("dp.hide", options.change);
        // in der version 4.17 dürfen keine optionen vorhanden sein, welche nicht unterstützt werden.
        // format: aktuelles moment-datums format
        $container.datetimepicker({
            format: options.format,
            locale: options.culture,
            useCurrent: true,
            icons: options.icons
        });
        //
        // Subscribe on change
        $container.on('dp.change', function (e) {
            if (ko.isObservable(valueAccessor().value)) {
                valueAccessor().value(moment(e["date"]).format(Bao.Utils.DateTimeFormat));
            }
            $(element).change();
        });
        $(element).data("baoDateTimePicker", { $container: $container });
        baoDatePicker.update(element, valueAccessor, allBindingsAccessor, viewModel, bindingContext);
    },
    update: function (element, valueAccessor, allBindings, viewModel) {
        const config = ko.toJS(valueAccessor());
        const disabled = ko.utils.unwrapObservable(config.disabled);
        const minDate = ko.utils.unwrapObservable(config.minDate);
        const maxDate = ko.utils.unwrapObservable(config.maxDate);
        const $container = $(element).data("baoDateTimePicker").$container;
        if (disabled && $(element).parent().has("span").length) {
            $(element).parent().children("span").remove();
        }
        else if (!disabled) {
        }
        var dtPicker = $container.data('DateTimePicker');
        if (config.value != null) {
            var m = moment(config.value, Bao.Utils.DateTimeFormat);
            if (m.isValid()) {
                dtPicker.date(m);
            }
        }
        if (minDate || maxDate) {
            if (dtPicker) {
                if (minDate) {
                    var minDateTime = moment(minDate, Bao.Utils.DateTimeFormat); //.subtract('d', 1);
                    if (minDateTime.isValid()) {
                        dtPicker.minDate(minDateTime);
                    }
                    else {
                        dtPicker.minDate(null);
                    }
                }
                if (maxDate) {
                    var maxDateTime = moment(maxDate, Bao.Utils.DateTimeFormat); //.add('d', 1);
                    if (maxDateTime.isValid()) {
                        dtPicker.maxDate(maxDateTime);
                    }
                    else {
                        dtPicker.maxDate(null);
                    }
                }
            }
        }
    }
};
ko.bindingHandlers["finitoDatePicker"] = baoDatePicker;
ko.bindingHandlers["baoDateTimePicker"] = baoDatePicker;
ko.bindingHandlers["baoDatePicker"] = baoDatePicker;